<ng-container *transloco="let t">
    <ng-container
        *ngIf="{
            required: required$ | async,
            valueChanges: valueChanges$ | async,
            statusChanges: statusChanges$ | async
        } as data"
    >
        <bazis-input-default
            [formControl]="field"
            [titleKey]="titleKey"
            [tooltipKey]="tooltipKey"
            [title]="title"
            [isEmptyLabel]="isEmptyLabel"
            [tooltipParams]="tooltipParams"
            [placeholderKey]="placeholderKey"
            [placeholder]="placeholder"
            [titleParams]="titleParams"
            [hasTitleMajor]="hasTitleMajor"
            [tooltipSettings]="tooltipSettings"
            [noteKey]="noteKey"
            [noteParams]="noteParams"
            [leftIcon]="leftIcon"
            [isLeftIconClickable]="isLeftIconClickable"
            [rightIcon]="rightIcon"
            [isRightIconClickable]="isRightIconClickable"
            [required$]="required$"
            [validationErrorMessages]="validationErrorMessages"
            [hasEraser]="hasEraser"
            [withoutInnerPadding]="withoutInnerPadding"
            [maskSettings]="maskSettings"
            [beforeWrite]="beforeWrite"
            [sizeControl]="sizeControl"
        >
            <bazis-form-error
                *ngIf="field.status === 'VALID'"
                [validationErrorMessages]="validationErrorMessages"
                [formControl]="ngControl.control"
            ></bazis-form-error>

            <div
                class="bazis-control__note"
                ngProjectAs="note"
            >
                <bazis-link
                    *ngIf="enableForeignNumber"
                    borderStyle="none"
                    (click)="changeMaskType()"
                >
                    {{
                        currentMaskType === 'rf'
                            ? t('form.title.phone.toggleToForeign')
                            : t('form.title.phone.toggleToDefault')
                    }}
                </bazis-link>
            </div>
        </bazis-input-default>
    </ng-container>
</ng-container>
